import { MdCheck } from 'react-icons/md'
import { colors } from 'shared/styles/colors'
import styled from 'styled-components'

export const TitleModal = styled.h2`
  font-family: 'Roboto';
  font-size: 24px;
  font-weight: 700;
  color: ${colors.black};
  margin-bottom: 20px;
  padding-left: 12px;
  padding-top: 40px;
  margin: 0 auto;
`

export const Message = styled.div`
  width: 100%;
  height: 100%;
`

export const StyledCheck = styled(MdCheck)`
  color: ${colors.white};
  font-size: 80px !important;
  padding: 10px 10px 10px 10px;
  background: ${colors.green};
  border-radius: 50%;
`
